import { differenceInDays, format } from "date-fns";
import _ from "lodash";

export const getBillValue = (kbankid, amount, count = 0) => {
  const MONEY_HUB_TAX_ID = "010556313826600";
  if (count < 10) count = "0" + count;
  else count = "" + count;
  const ref_number = kbankid + count;
  return "|" + MONEY_HUB_TAX_ID + "\n" + ref_number + "\n\n" + amount + "00";
};

export const getRefId = (loan_kbank_id, countEvidence = 0) => {
  let count = countEvidence;

  if (count > 0) {
    count += 1;
  }

  if (countEvidence < 10) return loan_kbank_id + "0" + count;
  return `${loan_kbank_id}${count}`;
};

export const showAmountWithOutCurrent = (items, current) => {
  var sum = 0;

  var init = current;
  if (init < 0) init = 0;

  for (let i = init; i >= 0; i--) {
    let prev = items[i].actualPrinciple + items[i].actualInterest;

    if (items[i]?.displayStatus === "ปิด-โปะ") {
      continue;
    }
    if (prev > 0)
      sum += Number(items[i].actualPrinciple) + Number(items[i].actualInterest);
    else break;
  }
  return sum.toString();
};

export const getDifferentFromNow = (date) => {
  return differenceInDays(new Date(), new Date(date));
};

export const getNextInstallment = (installments) => {
  var current = 0;
  for (let i = 0; i < installments.length; i++) {
    var deadlineTime = new Date(installments[i].date + "T00:00+07:00").setHours(
      0,
      0,
      0,
      0
    );
    var today = new Date().setHours(0, 0, 0, 0);
    //console.log(deadlineTime + "  and " + today)
    if (deadlineTime >= today) {
      return i;
    }
  }
  return current;
};

export const getLoanCurrent = (loan) => {
  let current = 0;
  let item = loan.installments[0];

  let installments = _.cloneDeep(loan.installments);
  for (let i = 0; i < installments.length; i++) {
    const installment = installments[i];
    const checkCurrentDate =
      format(new Date(), "yyyy-MM-dd") <=
      format(new Date(installment.date), "yyyy-MM-dd");

    if (checkCurrentDate && !installment.disabledPeriod) {
      current = i;
      item = installment;
      break;
    }
  }

  let prevItem = installments[current - 1];

  if (loan.loan_status === "DONE") {
    current = prevItem;
  }

  return { current, item, prevItem };
};

// export const getValueAmount = (loan) => {
//   const { current, item, prevItem } = getLoanCurrent(loan);
//   const items = loan.installments;

//   if (
//     current > 0 &&
//     (Number(item.interestMore) > 0 || prevItem.actualPrinciple > 0)
//   ) {

//     // check if has penalty
//     /// sum all back up priciple until begin
//     if (getDifferentFromNow(prevItem.date) > 15 || current + 1 >  loan.period) {
//       return showAmountWithOutCurrent(items, current);
//     } else {
//       return showAmountWithOutCurrent(items, current - 1);
//     }
//   } else {
//     /// case first Installment or no penalty
//     return Number(item.actualPrinciple) + Number(item.actualInterest) + "";
//   }
// };

export const getValueAmount = (loan) => {
  const current = getNextInstallment(loan?.installments);
  const items = loan.installments;
  const item = loan.installments[current];
  let prevItem = {};

  if (current > 0) prevItem = loan.installments[current - 1];

  if (
    current > 0 &&
    (Number(item.interestMore) > 0 || prevItem.actualPrinciple > 0)
  ) {
    // check if has penalty
    /// sum all back up priciple until begin
    if (getDifferentFromNow(prevItem.date) > 15 || current + 1 > loan.period) {
      return showAmountWithOutCurrent(items, current);
    } else {
      return showAmountWithOutCurrent(items, current - 1);
    }
  } else {
    /// case first Installment or no penalty
    return Number(item.actualPrinciple) + Number(item.actualInterest) + "";
  }
};
